import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    padding: '12px 16px',
    height: '100%',
    borderRadius: '10000px',
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
}));
